import React from 'react';
import { Footer } from '@guildeducationinc/recess';
import { SALESFORCE_NEW_REQUEST_URL, SALESFORCE_URL } from '@src/constants';
import { useMemberPlanContext } from '@src/context/MemberPlanContext';

const HomeFooter: React.FC = () => {
  const { memberPlan, loading: loadingMemberPlan } = useMemberPlanContext();
  const isTrOnlyPlan = memberPlan?.hasTuitionReimbursementOnly;

  // customize default <Footer /> columns so that we can hide 'Programs' when the current plan is TR-Only
  // ideal future state: a Recess navigation module that lets us customize links in the header + footer
  // so as to avoid duplication and creation of multiple touch points in this fashion
  const contactFooterColumn = {
    title: 'Contact Us',
    links: [
      {
        href: SALESFORCE_URL,
        label: 'Help Center',
      },
      {
        href: SALESFORCE_NEW_REQUEST_URL,
        label: 'Message Guild Support',
      },
    ],
  };

  const productFooterColumn = {
    title: 'Product',
    links: [
      { href: 'https://www.guildeducation.com/students', label: 'Students' },
      { href: 'https://www.guildeducation.com/for_companies', label: 'Companies' },
    ],
  };

  // use of !loadingMemberPlan here prevents rendering the 'Programs' link before 'isTrOnlyPlan' is determined
  if (!loadingMemberPlan && !isTrOnlyPlan) {
    productFooterColumn.links.push({
      href: 'https://catalog.guildeducation.com',
      label: 'Programs',
    });
  }

  const guildFooterColumn = {
    title: 'Guild',
    links: [
      { href: 'https://www.guildeducation.com/careers', label: 'Careers' },
      { href: 'https://www.guildeducation.com/press', label: 'Press' },
      { href: 'https://www.guildeducation.com/who-we-are', label: 'Who We Are' },
    ],
  };
  return (
    <Footer
      columns={[contactFooterColumn, productFooterColumn, guildFooterColumn]}
      includeDefaultColumns={false}
      headingTag='h3'
    />
  );
};

export default HomeFooter;
